module.exports = __webpack_public_path__ + "static/mami-2a18ebbd4deca54ae2f4d34bbc01d0cc.jpg";